module.exports = __webpack_public_path__ + "img/close-dark.5fefb226.svg";